// 格式化单据号
const formatBillNo = (billNo: string) => {
    try {
        return billNo.replace(/(^[A-Z]*)(\d{4})(\d{2})(\d{2})(\d{4})/ig, (...args) => {
            return `${args[1]}-${args[2]}-${args[3]}-${args[4]}-${args[5]}`
        })
    } catch {
        return billNo
    }
}

export default formatBillNo